import CalendarIconV2 from "$/lib/icons/CalendarIconV2";
import DragIcon from "$/lib/icons/DragIcon";
import MaximizeIcon from "$/lib/icons/MaximizeIcon";
import MinimizeIcon from "$/lib/icons/MinimizeIcon";
import TrashIcon from "$/lib/icons/TrashIcon";
import type { ThemeChoices } from "$/lib/types/General.types";
import { useSortable } from "@dnd-kit/sortable";
import { customColors } from "tailwind.config";
import Flexbox from "../../common/Flexbox";
import { DatePickerInput } from "../../molecules";
import WidgetButton from "../WidgetButton";
import DeleteWidgetModal from "../DeleteWidgetModal";
import { useState } from "react";

type Props = {
  id: string;
  expanded: boolean;
  selectedDate?: Date;
  setSelectedDate?: (date: Date) => void;
  theme?: ThemeChoices;
  handleToggle: VoidFunction;
  handleDelete: VoidFunction;
  isLargeItem?: boolean;
};

const WidgetButtons = ({
  id,
  expanded,
  theme = "blue",
  selectedDate,
  setSelectedDate,
  handleToggle,
  handleDelete,
  isLargeItem = true,
}: Props) => {
  const { attributes, listeners } = useSortable({ id });

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const handleDeleteWidget = () => {
    handleDelete();
    setIsDeleteModalOpen(false);
  };

  return (
    <>
      <Flexbox row align="center" className="relative gap-2">
        <WidgetButton onClick={handleToggle}>
          {expanded ? (
            <MinimizeIcon
              fill={
                theme === "green"
                  ? customColors.forest.DEFAULT
                  : theme === "orange"
                    ? customColors.warning.DEFAULT
                    : customColors.secondary.DEFAULT
              }
              height={18}
              width={18}
            />
          ) : (
            <MaximizeIcon
              fill={
                theme === "green"
                  ? customColors.forest.DEFAULT
                  : theme === "orange"
                    ? customColors.warning.DEFAULT
                    : customColors.secondary.DEFAULT
              }
              height={18}
              width={18}
            />
          )}
        </WidgetButton>

        <button
          key={id}
          {...listeners}
          {...attributes}
          type="button"
          className="ml-auto cursor-pointer rounded-full bg-white p-2 shadow outline-none transition-shadow hover:shadow-lg"
        >
          <DragIcon
            fill={
              theme === "green"
                ? customColors.forest.DEFAULT
                : theme === "orange"
                  ? customColors.warning.DEFAULT
                  : customColors.secondary.DEFAULT
            }
            height={18}
            width={18}
          />
        </button>

        {selectedDate && (
          <DatePickerInput
            selected={selectedDate}
            onChange={(value) =>
              value && setSelectedDate && setSelectedDate(value)
            }
            popperPlacement={isLargeItem ? "bottom-end" : "bottom"}
            calendarIcon={
              <CalendarIconV2
                fill={
                  theme === "blue"
                    ? customColors.secondary.DEFAULT
                    : theme === "green"
                      ? customColors.forest.DEFAULT
                      : customColors.warning.DEFAULT
                }
              />
            }
            theme={theme}
            customInput={
              <WidgetButton>
                <CalendarIconV2
                  fill={
                    theme === "green"
                      ? customColors.forest.DEFAULT
                      : theme === "orange"
                        ? customColors.warning.DEFAULT
                        : customColors.secondary.DEFAULT
                  }
                  height={18}
                  width={18}
                />
              </WidgetButton>
            }
          />
        )}

        <WidgetButton onClick={() => setIsDeleteModalOpen(true)}>
          <TrashIcon height={18} width={18} />
        </WidgetButton>
      </Flexbox>

      <DeleteWidgetModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        handleDelete={handleDeleteWidget}
      />
    </>
  );
};

export default WidgetButtons;
